// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.pagination-bottom-fixed {
    height: 500px !important;
    overflow-y: scroll;
    .ant-pagination, .ant-list-pagination {
        bottom: 0 !important;
    }
}

.col-pagination {
    padding-top: 20px;
    border-right: 1px solid black;
}

.list-item-ant > .ant-collapse-item {
    cursor: pointer;
    padding: 5px;
    width: 100%;
    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
}

.list-item-ant > .ant-collapse-item {
    border-bottom: 1px black solid;
}


.ant-collapse-header:hover {
    background-color: rgba(0, 0, 0, 0.06);
    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    color: #a368fc; /* Color del texto se mantiene */
}

.ant-collapse-item-active > .ant-collapse-header, .ant-collapse-item-active > .ant-collapse-header:hover {
    cursor: pointer;
    padding: 10px;
    width: 100%;
    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    background-color: #f9f0ff; /* Color de fondo más claro al hacer clic */
    color: #a368fc; /* Color del texto se mantiene */
}

.list-item-ant-selected {
    cursor: pointer;
    padding: 5px;
    width: 100%;
    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);
    background-color: #f9f0ff; /* Color de fondo más claro al hacer clic */
    color: #a368fc; /* Color del texto se mantiene */
}

.ant-radio-inner {
    border-color: #a368fc !important;
    border-width: 2px !important;
}`, "",{"version":3,"sources":["webpack://./src/components/UsageLimits/usage-limits.css"],"names":[],"mappings":"AAAA;IACI,wBAAwB;IACxB,kBAAkB;IAClB;QACI,oBAAoB;IACxB;AACJ;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;AACjC;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,iGAAiG;AACrG;;AAEA;IACI,8BAA8B;AAClC;;;AAGA;IACI,qCAAqC;IACrC,iGAAiG;IACjG,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,eAAe;IACf,aAAa;IACb,WAAW;IACX,iGAAiG;IACjG,yBAAyB,EAAE,2CAA2C;IACtE,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,eAAe;IACf,YAAY;IACZ,WAAW;IACX,iGAAiG;IACjG,yBAAyB,EAAE,2CAA2C;IACtE,cAAc,EAAE,gCAAgC;AACpD;;AAEA;IACI,gCAAgC;IAChC,4BAA4B;AAChC","sourcesContent":[".pagination-bottom-fixed {\n    height: 500px !important;\n    overflow-y: scroll;\n    .ant-pagination, .ant-list-pagination {\n        bottom: 0 !important;\n    }\n}\n\n.col-pagination {\n    padding-top: 20px;\n    border-right: 1px solid black;\n}\n\n.list-item-ant > .ant-collapse-item {\n    cursor: pointer;\n    padding: 5px;\n    width: 100%;\n    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n}\n\n.list-item-ant > .ant-collapse-item {\n    border-bottom: 1px black solid;\n}\n\n\n.ant-collapse-header:hover {\n    background-color: rgba(0, 0, 0, 0.06);\n    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    color: #a368fc; /* Color del texto se mantiene */\n}\n\n.ant-collapse-item-active > .ant-collapse-header, .ant-collapse-item-active > .ant-collapse-header:hover {\n    cursor: pointer;\n    padding: 10px;\n    width: 100%;\n    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    background-color: #f9f0ff; /* Color de fondo más claro al hacer clic */\n    color: #a368fc; /* Color del texto se mantiene */\n}\n\n.list-item-ant-selected {\n    cursor: pointer;\n    padding: 5px;\n    width: 100%;\n    transition: border-color 0.3s, background 0.3s, padding 0.3s cubic-bezier(0.645, 0.045, 0.355, 1);\n    background-color: #f9f0ff; /* Color de fondo más claro al hacer clic */\n    color: #a368fc; /* Color del texto se mantiene */\n}\n\n.ant-radio-inner {\n    border-color: #a368fc !important;\n    border-width: 2px !important;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
